/**
 * A custom error to throw when the API returns an unauthenticated response code
 */
export class AuthenticationError extends Error {}
